var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F2FFFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.269 23.102 1.445 6.178h16.57l1.447-6.178c.03-.133-.07-.167-.19-.208a.812.812 0 0 1-.181-.079l-.72-.465a.707.707 0 0 1-.147-.155c-.083-.105-.163-.208-.26-.16l-3.724 1.862-3.465-5.997c-.049-.084-.136-.038-.234.014a.463.463 0 0 1-.21.072h-1.156c-.073-.002-.154-.05-.229-.096-.107-.065-.203-.123-.255-.033l-3.518 6.088-3.724-1.861c-.097-.048-.165.032-.238.12a.628.628 0 0 1-.136.132l-.704.404a1.582 1.582 0 0 1-.132.07c-.142.072-.275.139-.24.292zm1.112.366 1.126 4.812h14.984l1.115-4.761-.482-.311-3.168 1.583-.842.421-.471-.815-3.127-5.411h-1.053l-3.156 5.46-.47.815-.843-.421-3.208-1.605-.405.233z",
    fill: "#35404A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.66 32.62H16.34v-1.88h15.32v1.88z",
    stroke: "#31B59F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.466a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88zm9.6 4.8a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88zm-19.2 0a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88z",
    stroke: "#31B59F",
    strokeWidth: 0.96,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.1713da398fe061b176ae9f83699bc2e8.svg";
export { ForwardRef as ReactComponent };